import React, { SVGProps } from 'react'
const SvgOrganizationInvite = (
  props: SVGProps<SVGSVGElement>,
): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width={170}
    height={148}
    aria-hidden="true"
    {...props}
  >
    <defs>
      <filter
        id="Organization-Invite_svg__a"
        width="124.6%"
        height="124.8%"
        x="-12.3%"
        y="-9.8%"
        filterUnits="objectBoundingBox"
      >
        <feOffset dy={5} in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
          stdDeviation={7}
        />
        <feColorMatrix
          in="shadowBlurOuter1"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
        />
      </filter>
      <filter
        id="Organization-Invite_svg__e"
        width="159.2%"
        height="147.7%"
        x="-29.6%"
        y="-18.8%"
        filterUnits="objectBoundingBox"
      >
        <feOffset dy={5} in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
          stdDeviation={7}
        />
        <feColorMatrix
          in="shadowBlurOuter1"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
        />
      </filter>
      <filter
        id="Organization-Invite_svg__g"
        width="159.2%"
        height="147.7%"
        x="-29.6%"
        y="-18.8%"
        filterUnits="objectBoundingBox"
      >
        <feOffset dy={5} in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
          stdDeviation={7}
        />
        <feColorMatrix
          in="shadowBlurOuter1"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
        />
      </filter>
      <filter
        id="Organization-Invite_svg__i"
        width="140.9%"
        height="129.5%"
        x="-20.4%"
        y="-11%"
        filterUnits="objectBoundingBox"
      >
        <feOffset dy={5} in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
          stdDeviation={7}
        />
        <feColorMatrix
          in="shadowBlurOuter1"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
        />
      </filter>
      <filter
        id="Organization-Invite_svg__k"
        width="140.9%"
        height="129.5%"
        x="-20.4%"
        y="-11%"
        filterUnits="objectBoundingBox"
      >
        <feOffset dy={5} in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
          stdDeviation={7}
        />
        <feColorMatrix
          in="shadowBlurOuter1"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
        />
      </filter>
      <path id="Organization-Invite_svg__c" d="M0 0h333.975v156.038H0z" />
      <path
        id="Organization-Invite_svg__f"
        d="m114.975 54.75 72.456 14.646a8.645 8.645 0 0 1 6.932 8.474v66.785a8.645 8.645 0 0 1-8.645 8.645h-70.743V54.75Z"
      />
      <path
        id="Organization-Invite_svg__h"
        d="m0 0 72.455 14.646a8.645 8.645 0 0 1 6.933 8.474v66.785a8.645 8.645 0 0 1-8.645 8.645H0V0Z"
      />
      <path
        id="Organization-Invite_svg__j"
        d="m10.188 1.849 97.686 17.724a8.645 8.645 0 0 1 7.101 8.506V153.3H8.645A8.645 8.645 0 0 1 0 144.655v-134.3a8.645 8.645 0 0 1 10.188-8.506Z"
      />
      <path
        id="Organization-Invite_svg__l"
        d="m10.188 10.061 97.686 17.725a8.645 8.645 0 0 1 7.101 8.506v125.22H8.645A8.645 8.645 0 0 1 0 152.869v-134.3a8.645 8.645 0 0 1 10.188-8.507Z"
      />
      <ellipse
        id="Organization-Invite_svg__b"
        cx={116.153}
        cy={98.111}
        rx={95.593}
        ry={94.733}
      />
    </defs>
    <g fill="none" fillRule="evenodd">
      <g transform="rotate(-30 -48.648 47.133)">
        <use
          xlinkHref="#Organization-Invite_svg__b"
          fill="#000"
          filter="url(#Organization-Invite_svg__a)"
        />
        <use xlinkHref="#Organization-Invite_svg__b" fill="#FCFCFF" />
      </g>
      <path d="M166.93 90.922c41.645-24.044 58.514-74.414 41.423-117.444-1.673-4.212-9.41-19.781-11.743-23.821-26.16-45.31-78.692-49.215-124.414-22.818-28.07 16.206-67.73 24.26-70.476 54.078-1.727 18.75 24.957 58.267 35.057 75.76 26.16 45.31 84.431 60.642 130.153 34.245Z" />
      <g transform="rotate(-30 52.585 145.933)">
        <mask id="Organization-Invite_svg__d" fill="#fff">
          <use xlinkHref="#Organization-Invite_svg__c" />
        </mask>
        <g mask="url(#Organization-Invite_svg__d)">
          <g transform="translate(80.993 7.657)">
            <use
              xlinkHref="#Organization-Invite_svg__f"
              fill="#000"
              filter="url(#Organization-Invite_svg__e)"
            />
            <use xlinkHref="#Organization-Invite_svg__f" fill="#2B88FF" />
          </g>
          <g opacity={0.1} transform="translate(195.968 70.62)">
            <use
              xlinkHref="#Organization-Invite_svg__h"
              fill="#000"
              filter="url(#Organization-Invite_svg__g)"
            />
            <use xlinkHref="#Organization-Invite_svg__h" fill="#F6F7FB" />
          </g>
          <path
            stroke="#FFF"
            strokeLinecap="round"
            strokeWidth={8.645}
            d="M213.525 121.819h14.12"
            opacity={0.5}
          />
          <path
            stroke="#FFF"
            strokeLinecap="round"
            strokeWidth={8.645}
            d="M213.525 140.982h14.12M213.525 101.638h14.12"
            opacity={0.25}
          />
          <path
            stroke="#FFF"
            strokeLinecap="round"
            strokeWidth={8.645}
            d="M246.375 121.819h14.12M246.375 140.982h14.12"
            opacity={0.5}
          />
          <path
            stroke="#FFF"
            strokeLinecap="round"
            strokeWidth={8.645}
            d="M246.375 101.638h14.12"
            opacity={0.25}
          />
          <g transform="translate(80.993 7.657)">
            <use
              xlinkHref="#Organization-Invite_svg__j"
              fill="#000"
              filter="url(#Organization-Invite_svg__i)"
            />
            <use
              xlinkHref="#Organization-Invite_svg__j"
              fill={props.fill || 'var(--color-highlight)'}
            />
          </g>
          <g opacity={0.1} transform="translate(80.993 7.657)">
            <use
              xlinkHref="#Organization-Invite_svg__l"
              fill="#000"
              filter="url(#Organization-Invite_svg__k)"
            />
            <use xlinkHref="#Organization-Invite_svg__l" fill="#F6F7FB" />
          </g>
          <path
            fill="#F6F7FB"
            d="M130.7 130.845h18.298a8.645 8.645 0 0 1 8.645 8.645v21.467h-35.588V139.49a8.645 8.645 0 0 1 8.645-8.645Z"
          />
          <path
            stroke="#FFF"
            strokeLinecap="round"
            strokeWidth={8.645}
            d="M108.368 102.174h17.29M108.368 76.24h17.29"
          />
          <path
            stroke="#9ADED0"
            strokeLinecap="round"
            strokeWidth={8.645}
            d="M108.368 50.304h17.29M152.168 102.174h17.29M152.168 76.24h17.29"
          />
          <path
            stroke="#FFF"
            strokeLinecap="round"
            strokeWidth={8.645}
            d="M152.168 50.304h17.29"
          />
        </g>
      </g>
    </g>
  </svg>
)
export default SvgOrganizationInvite
